import { Parchment } from 'quill/core';

const HeaderCollapse = new Parchment.Attributor(
  'header-collapse',
  'header-collapse',
  {
    scope: Parchment.Scope.BLOCK_ATTRIBUTE,
    whitelist: ['true'],
  },
);

export default HeaderCollapse;
